export function handleApiErrors(form, apiErrors) {
  if (!apiErrors) return;

  Object.entries(apiErrors).forEach(([fieldName, messages]) => {

    if (messages && messages.length > 0) {
      form.setError(fieldName, {
        type: 'server',
        message: messages.join(', ')
      });
    }
  });
}